require('./createChoreStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');
const dateHelper = require('utilities/dateHelper');

// @constants
const { DATE_FORMAT_ES } = require('constants/index');

class CreateChoreStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.createList = this.createList.bind(this);
    }

    createList(list){
        return(
            list.map((data, index) => {
                if(data.key){
                    return(
                        <OKInformativeListItem
                            className={"create-chore-step-two__list-item"}
                            bodyText={data.key}
                            key={index}
                            title={data.title}
                            bodyWordBreak={false}
                        />
                    )
                }
            })
        )
    }

    render() {
        const { immCard, immOpenYoungCardCreateChore } = this.props;
        const chore = formatText(`openYoungCardChores-task${immOpenYoungCardCreateChore.getIn(['choreType',0,'choreId'])}`);
        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const amount = [
            getFormattedString({ amount: immOpenYoungCardCreateChore.get('amount'), currency })
        ];
        const selectedEndDate = dateHelper.buildFormattedDate(
            immOpenYoungCardCreateChore.get('selectedEndDate'),
            DATE_FORMAT_ES
        );
        const concept = immOpenYoungCardCreateChore.get('concept');
        const selectedRepetitionType = immOpenYoungCardCreateChore.getIn(['selectedRepetitionType','value']);
        const list = [
            {
                key: chore,
                title: formatText('createChoreStep-chore')
            },
            {
                key: amount,
                title: formatText('createChoreStep-amount')
            },
            {
                key: selectedEndDate,
                title: formatText('createChoreStep-selectedEndDate')
            },
            {
                key: selectedRepetitionType,
                title: formatText('createChoreStep-repetitions')
            },
            {
                key: concept,
                title: formatText('createChoreStep-concept')
            }
        ];
        return (
            <section className="create-chore-step-two row">
                <header className="create-chore-step-two__header">
                    <FormattedText value="createChoreStep2-title" className="create-chore-step-two__title" />
                    <FormattedText value="createChoreStep2-subTitle" className="create-chore-step-two__sub-title" />
                </header>
                <OKInformativeList columns={2}>
                    {this.createList(list)}
                </OKInformativeList>
            </section>
        )
    }
}

CreateChoreStep2.propTypes = {
    immCard: PropTypes.object.isRequired,
    immOpenYoungCardCreateChore: PropTypes.object.isRequired
};

module.exports = CreateChoreStep2;
